import React, { useCallback, useState, Suspense, lazy } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import './Gallery.css';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import { canCreateContentForTenant } from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';

const GalleryCreate = lazy(() => import('./GalleryCreate'));
const GalleryList = lazy(() => import('./GalleryList'));
const GalleryDetail = lazy(() => import('./GalleryDetail'));

function Gallery() {
    const [selectedGallery, setSelectedGallery] = useState(null);
    const [showCreateGallery, setShowCreateGallery] = useState(false);
  
    const { user } = useUser();
    const { tenantId } = useTenant();
    const { memberships } = useMembership();
    const canCreateGallery = canCreateContentForTenant(memberships, tenantId, user);

    const handleSelectGallery = (gallery) => {
        setSelectedGallery(gallery);
        setShowCreateGallery(false);
    };

    const resetToList = useCallback(() => {
        setSelectedGallery(null);
        setShowCreateGallery(false);
    }, []);

    const onList = !selectedGallery && !showCreateGallery;
    const closeDetailView = useBrowserBackStack(!onList, resetToList);

    const toggleCreateGalleryForm = () => {
        if (showCreateGallery) {
            closeDetailView();
            return;
        }
        setShowCreateGallery(true);
        setSelectedGallery(null);
    };

    const handleGalleryCreated = () => {
        setShowCreateGallery(false);
        setSelectedGallery(null);
    };

    const containerClass = 'platform-module-container gallery-container';
    const headerTitle = selectedGallery?.title
      || (showCreateGallery ? 'Nova galerija' : 'Galerija');

    return (
        <div className={containerClass}>
                <ModulePageHeader
                    eyebrow={!onList ? 'Galerija' : undefined}
                    title={headerTitle}
                    subtitle={onList ? 'Fotografije in dogodki sindikata.' : undefined}
                    actions={(
                        <>
                            {canCreateGallery && !selectedGallery && (
                                <Button variant="primary" onClick={toggleCreateGalleryForm}>
                                    {showCreateGallery ? 'Nazaj na izbiro' : 'Ustvari galerijo'}
                                </Button>
                            )}
                            {selectedGallery && (
                                <Button variant="primary" onClick={closeDetailView}>Nazaj na izbiro</Button>
                            )}
                        </>
                    )}
                />
                <Suspense fallback={<Spinner animation="border" />}>
                    {!selectedGallery ? (
                        showCreateGallery ? (
                            <GalleryCreate onGalleryCreated={handleGalleryCreated} />
                        ) : (
                            <GalleryList onSelectGallery={handleSelectGallery} isAdmin={canCreateGallery} />
                        )
                    ) : (
                        <GalleryDetail gallery={selectedGallery} />
                    )}
                </Suspense>
        </div>
    );
}

export default Gallery;
